<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-row>
                    <el-form-item label="供应商代码" prop="venderCode">
                        <el-input size="mini" v-model="venderCode" style="width: 150px" placeholder="供应商代码" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="venderName">
                        <el-input size="mini" v-model="venderName" style="width: 150px" placeholder="供应商名称" clearable @blur="getDataList"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="mini" @click="queryHandle()" icon="el-icon-search" style="margin-left:20px">查询
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>

        <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini"  highlight-current-row
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle" border :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column
            type="index"
            width="50">
            </el-table-column>
            <el-table-column prop="supplierLevel" header-align="center" align="center" label="等级" min-width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.supplierLevel == '0'">潜在</span>
                    <span v-if="scope.row.supplierLevel == '1'">合格</span>
                    <span v-if="scope.row.supplierLevel == '2'">一次性</span>
                </template>
            </el-table-column>
            <el-table-column prop="venderLogin" header-align="center" align="left" label="供应商账号" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderLogin }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCodeStorage" header-align="center" align="left" label="供应商代码" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.venderCodeStorage }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="160">
                <template slot-scope="scope">
                    {{ scope.row.venderName }}
                </template>
            </el-table-column>
            <el-table-column prop="applyStatus" header-align="center" align="left" label="审批状态" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.applyStatus }}
                </template>
            </el-table-column>
            <el-table-column prop="disReason" header-align="center" align="left" label="驳回原因" min-width="130">
                <template slot-scope="scope">
                    {{ scope.row.disReason }}
                </template>
            </el-table-column>
            <el-table-column prop="disReason" header-align="center" align="center" label="审批历史" min-width="100px">
                    <template slot-scope="scope">
                        <el-button @click="doHistory(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            <el-table-column prop="createTimeStr" header-align="center" align="left" label="创建时间" min-width="140"  >
                <template slot-scope="scope">
                    {{ scope.row.createTimeStr }}
                </template>
            </el-table-column>

            <el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="130px">
                <template slot-scope="scope" v-if="isButton(scope.row)">
                    <el-button type="text" size="small" @click="updateCodeView(scope.row)" icon="el-icon-edit">维护</el-button>
                
                    <el-button type="text" size="small" @click="applyCode(scope.row)" icon="el-icon-edit">提交</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        </div>

        <el-dialog title="修改供应商代码" width="50%" :close-on-click-modal="false" :visible.sync="dialogVisible2" :rules="dataRule2" @close='closeDialog2'>
            <div style="margin-top: 30px;" v-loading="updateLoading">
                <el-form :model="temp2" label-width="120px" :rules="dataRule2" size="mini" ref="temp2" style="margin-top:5px">
                    <el-row :gutter="80">
                        <el-col :span="11">
                            <el-tooltip placement="top" content='' effect="light">
                                <div slot="content">{{temp2.venderName}}</div>
                                <el-form-item label="供应商名称：" prop="venderName">
                                    <el-input :disabled='true' v-model="temp2.venderName"/>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="11">
                            <el-tooltip placement="top" content='' effect="light">
                                <div slot="content">{{temp2.venderCodeStorage}}</div>
                                <el-form-item label="供应商代码：" prop="venderCode">
                                    <el-input :disabled='false' v-model="temp2.venderCodeStorage"/>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="11">
                            <el-tooltip placement="top" content='' effect="light">
                                <el-form-item label="省份" prop="province">
                                <!-- <el-select disabled v-model="temp2.province" style="width: 100%;" clearable>
                                    <el-option
                                    v-for="item in provinceOptions"
                                    :key="item.province"
                                    :label="item.label"
                                    :value="item.province">
                                    </el-option>
                                </el-select> -->
                                  <el-select disabled v-model="temp2.province" filterable clearable placeholder="请选择省份" style="width: 100%;">
                                      <el-option v-for="item in provinceOptions" :key="item.province" :label="item.name" :value="item.province">
                                      </el-option>
                                  </el-select>
                                </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="11">
                            <el-tooltip placement="top" content='' effect="light">
                              <el-form-item label="省份编码" prop="province">
                                <el-input :disabled='true' v-model="temp2.province"/>
                              </el-form-item>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="11">
                            <el-tooltip placement="top" content='' effect="light">
                              <el-form-item label="分组" prop="buGroup">
                                <el-select @change="getVenderCodeStorage(temp2.buGroup)" v-model="temp2.buGroup" placeholder="请选择">
                                    <el-option
                                    v-for="item in buGroups"
                                    :key="item.buGroup"
                                    :label="item.label"
                                    :value="item.buGroup">
                                    </el-option>
                                </el-select>
                              </el-form-item>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer">
                <el-button type="primary" @click="updateCode()" size="mini">确定</el-button>
                <el-button @click="dialogVisible2 = false" size="mini">取 消</el-button>
            </span>
        </el-dialog>

        <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
            <div v-for="str in historyList" :key="str">
                <el-descriptions :title="str.executeTime">
                        <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
                        <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
                </el-descriptions>
              <el-divider></el-divider>
            </div>
        </el-drawer>

    </div>
</template>
<script>

import {selectQualifiedCodeApplyPage, applyQualifiedCode, updateSupplierCodeById,createSupplierCode} from '@/controller/supplier'
import {listCommentHistory} from '@/controller/workflow'
import {listItems} from '@/controller/sys'
import {getProvinceList} from '@/controller/systemData'

export default {
    data() {
        return {
  
            dialogVisible2: false,
            updateLoading:false,
                dataForm: {
                    key: '',
                    province:'',
                    name:'',
                },
                flag: '',
                gpsStatusvalflag: '',
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                venderName: '',
                checkCreated: true,
                checkInvited: true,
                something: '',
                style: {
                    leftStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                        overflow: "auto"
                    },
                    rightStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
                    },
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
                    }
                },
                
               

                // 必填项
                dataRule2 : {
                    venderCodeStorage: [{
                        required: true,
                        message: '供应商代码不能为空',
                        trigger: 'blur'
                    }],
                    
                },

                temp:{
                    venderCode : '',
                    id:'',
                    venderInviteFid:'',
                },

                temp2:{
                    venderCodeStorage : '',
                    id:'',
                    venderInviteFid:'',
                    venderName:'',
                    province:'',
                    buGroup:'',
                },

                currentRow: null,
                

                venderCode : '',
                enterpriseName : '',
                // 审批历史
                drawer: false,
                // 审批列表
                historyList:[],

                // 分组
                buGroups:[],

                // 省
                provinceOptions:[],

   
        }
    },

    components: {
          
    },
    watch :{
        
    },

    activated() {
        this.flag = this.$route.params.gpsStatusvalflag
        if (this.flag === "1") {
            this.checkCreated = true
            this.checkInvited = false
        }
        if (this.$route.query && this.$route.query.gpsStatusval && this.$route.query.gpsStatusval.length > 0) {
            this.gpsStatusval = encodeURI(JSON.stringify(this.$route.query.gpsStatusval))
        } else {
            this.gpsStatusval = ''
        }
        this.getDataList()
        this.getAllStatus()
        this.getProvinceList()
    },

    methods: {

        getAllStatus(){
                listItems({
                    'codeType': 'BU_GROUP'
                }).then(data => {
                    if (data && data.code === '00') {
                        this.buGroups = data.body.body.map(str => {
                            return {'buGroup': str.itemValue, 'label': str.itemText}
                        })
                        console.log(this.buGroups)
                    }
                })
            },

         dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },

         // 查询按钮
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                selectQualifiedCodeApplyPage({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'venderCode': this.venderCode,
                    'venderName' : this.venderName
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                        this.starttime = data.starttime
                        this.endtime = data.endtime
                        this.interfacestarttime = data.endtime
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            //多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
                console.log(this.dataListSelections)
            },
            //单选
            radioChange(row) {
                this.dataListSelections = row;
            },

            // 修改代码弹窗显示
            updateCodeView(row){
               this.temp2.venderCodeStorage = row.venderCodeStorage,
               this.temp2.id = row.id,
               this.temp2.venderInviteFid = row.venderInviteFid,
               this.temp2.venderName = row.venderName,
               this.temp2.province = row.province,
               this.temp2.buGroup = row.buGroup,

               this.dialogVisible2 = true;
            },

            // 修改供应商代码
            updateCode(){
                console.log("修改供应商代码")
                this.$confirm(`确定修改?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.updateLoading = true;

                        updateSupplierCodeById(
                            {
                              id : this.temp2.id,
                              venderCode : this.temp2.venderCodeStorage,
                              buGroup : this.temp2.buGroup,
                             }
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success',
                                        duration: 1000,
                                        onClose: () => {
                                            this.dialogVisible2 = false
                                            this.getDataList()
                                        }
                                    })
                                    this.updateLoading = false;
                                } else {
                                    this.getVenderCodeStorage(this.temp2.buGroup)
                                    this.$message.error(data.msg + '，以为您重新生成供应商编码')
                                    this.updateLoading = false;
                                }
                      })

                    })
            },

            // 修改并申请-显示
            applyCode(row){
                if (!row.venderCodeStorage || row.venderCodeStorage.length <= 0) {
                    this.$message.error("请维护并填写[供应商代码]，再进行提交。");
                    return false;
                }
                var taskId = null;
                if(row.taskActions != null && row.taskActions.length != 0){
                    taskId = row.taskActions[0].taskId
                }
                var tips = "供应商【"+ row.venderName +"】代码现为【" + row.venderCodeStorage + "】确定提交申请？";
                this.$confirm(tips, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                        applyQualifiedCode(
                            {
                              id : row.id,
                              venderCodeStorage : row.venderCodeStorage,
                              venderInviteFid : row.venderInviteFid,
                              taskId : taskId,
                              applyId : row.applyId,
                              workflowId : row.workflowId,
                             }
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '提交成功',
                                        type: 'success',
                                        duration: 500,
                                        onClose: () => {
                                            this.getDataList()
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                      })
                        
                    })
                
            },

            

            // 判断提交和维护按钮是否显示
            isButton(row){
                if(row.taskActions === null){
                    return true;
                }else if(row.taskActions.length === 0){
                    return false;
                }
                else if(row.taskActions[0].flowRuleType === null){
                    return true;
                }

                return false;
            },

            // 关闭弹框的事件
            closeDialog() {
                this.getDataList()
            },

            // 关闭弹框的事件
            closeDialog2() {
                this.getDataList()
            },

            // 审批历史
            doHistory(row){
                this.historyList = []
                if(row.workflowId){
                    listCommentHistory({'workflowId' : row.workflowId}).then(data => {
                        if (data && data.code === '00') {
                            this.historyList = data.body
                        } else {
                            this.$message.error(data.msg)
                        }
                   })

                }
                
                this.drawer = true

            },

            // 省份
            getProvinceList(){
                getProvinceList({
                    code: "",
                    name: "",
                }).then(data => {
                    if (data && data.code === '00') {
                        //this.provinceOptions = data.body;

                        this.provinceOptions = data.body.map(str => {
                            return {'province': str.code, 'name': str.name}
                        })

                        console.log(this.provinceOptions,'省份')
                    }
                });
            },
            
            // 分组下拉会触发，会将【分组】与【省份编码】拼接到【供应商代码】
            getVenderCodeStorage(buGroup){
                var v1 = ''
                var v2 = ''
                if(buGroup){
                    // 临时方案，以后要改，暂时写死
                    if(buGroup === 'V005'){
                        buGroup = 'Y'
                    }else if(buGroup === 'VA01'){
                        buGroup = 'A'
                    }else if(buGroup === 'VB01'){
                        buGroup = 'B'
                    }else if(buGroup === 'VC01'){
                        buGroup = 'C'
                    }else{
                        buGroup = 'V'
                    }
                    v1 = buGroup
                }
                if(this.temp2.province){
                    v2 = this.temp2.province
                }
                
                var code;
               //TODO 有时间要在后面拼上流程编码
               if(v1 === 'Y'){
                   // Y 一次性要加5位流水，但不拼接省编码
                   //this.temp2.venderCodeStorage = v1
                   code = v1
               }else{
                   // 其它后面加3位流水
                   //this.temp2.venderCodeStorage = v1 + v2
                   code = v1 + v2
               }

               createSupplierCode({code:code}).then(data => {
                   if(data && data.code === '00'){
                       this.temp2.venderCodeStorage = data.body
                   }
               })
            },
            
    }
}
</script>

<style lang="scss">
    .button-danger { color: #F56C6C; }
</style>
